import { useRef } from 'react';
import { useGridRenderer } from '@/hooks/useGridRenderer';
import styles from '../SpatialCanvas.module.css';

/**
 * World renderer, background half: a single canvas painting the adaptive grid and
 * origin axes in screen space. It never holds React state; the camera drives it
 * through a frame-scheduled subscription.
 */
export const WorldBackground = () => {
  const ref = useRef<HTMLCanvasElement>(null);
  useGridRenderer(ref);
  return <canvas ref={ref} className={styles.background} aria-hidden="true" data-testid="world-background" />;
};
